import { toPng } from 'html-to-image';

function formatURI(params: { text: string }) {
  const safeText = (params.text || 'chart')
    .split(' ')
    .join('_')
    .replace(/[^a-z0-9_]/gi, '')
    .toLowerCase();
  return `vepc_capture_${safeText}.png`;
}

export async function takeSnapshot(params: { containerId: string; text: string }) {
  let chartContainer: HTMLElement | null = null;
  let dialogContent: HTMLElement | null = null;

  let origDialogShadow = '';
  let origDialogMaxHeight = '';
  let origContentMaxHeight = '';
  let origContentOverflow = '';

  try {
    const host = document.getElementById(params.containerId);
    if (!host) return;

    chartContainer = host.classList.contains('p-dialog') ? host : host.querySelector('.p-dialog') || host;
    dialogContent = chartContainer.querySelector('.p-dialog-content') as HTMLElement;

    origDialogShadow = chartContainer.style.boxShadow;
    origDialogMaxHeight = chartContainer.style.maxHeight;
    chartContainer.style.setProperty('box-shadow', 'none', 'important');
    chartContainer.style.setProperty('max-height', 'none', 'important');

    if (dialogContent) {
      origContentMaxHeight = dialogContent.style.maxHeight;
      origContentOverflow = dialogContent.style.overflow;
      dialogContent.style.setProperty('max-height', 'none', 'important');
      dialogContent.style.setProperty('overflow', 'visible', 'important');
    }

    await new Promise(resolve => setTimeout(resolve, 100));

    const filterElements = (node: HTMLElement) => {
      const exclusionClasses = [
        'capture-remove',
        'p-dialog-header-icons',
        'p-resizable-handle',
        'p-panel-header-icon',
        'p-dialog-close-button',
        'apexcharts-yaxistooltip',
        'apexcharts-toolbar',
        'snapshot-button'
      ];
      if (node?.classList && typeof node.classList.contains === 'function') {
        return !exclusionClasses.some(className => node.classList.contains(className));
      }
      return true;
    };

    const dataUrl = await toPng(chartContainer, {
      pixelRatio: 2,
      backgroundColor: '#ffffff',
      filter: filterElements,
      skipFonts: true
    });

    const link = document.createElement('a');
    link.download = formatURI(params);
    link.href = dataUrl;
    link.click();
    link.remove();
  } catch (error) {
    console.error('Snapshot capture error:', error);
  } finally {
    if (chartContainer) {
      chartContainer.style.boxShadow = origDialogShadow;
      chartContainer.style.maxHeight = origDialogMaxHeight;
    }
    if (dialogContent) {
      dialogContent.style.maxHeight = origContentMaxHeight;
      dialogContent.style.overflow = origContentOverflow;
    }
  }
}
